module.exports = "<div id=\"fullscreen-bg\">\r\n    <div id=\"fullscreen-reader\">\r\n        <div class=\"document-content\">\r\n\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/desktop/views/fullscreen-reader.html
// module id = 341
// module chunks = 1